const BACKEND_HEALTH_URL = "https://buzzys-backend.onrender.com/";
const WARMUP_INTERVAL_MS = 10 * 60 * 1000;
const REQUEST_TIMEOUT_MS = 15 * 1000;

export async function warmBackend() {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);

  try {
    const response = await fetch(BACKEND_HEALTH_URL, {
      method: "GET",
      cache: "no-store",
      signal: controller.signal,
    });

    return response.ok;
  } catch {
    // A timed-out request can still start a sleeping Render instance. This
    // check must never interrupt navigation, availability, or checkout.
    return false;
  } finally {
    window.clearTimeout(timeoutId);
  }
}

export function startBackendWarmup() {
  void warmBackend();

  const intervalId = window.setInterval(() => {
    if (document.visibilityState === "visible") {
      void warmBackend();
    }
  }, WARMUP_INTERVAL_MS);

  const warmWhenVisible = () => {
    if (document.visibilityState === "visible") {
      void warmBackend();
    }
  };

  document.addEventListener("visibilitychange", warmWhenVisible);

  return () => {
    window.clearInterval(intervalId);
    document.removeEventListener("visibilitychange", warmWhenVisible);
  };
}
